import { useState } from 'react';
import styled from 'styled-components';
import { color } from 'constants/styled-theme';
import { Container, InnerContainer, Success, Fail } from 'components/common/modal';
import { BasicButton } from 'components/common/button';

const CloseButton = styled(BasicButton)`
  position: absolute;
  top: 0;
  right: 0;
  margin: 5px;
  font-size: 20px;
  color: ${color('fontColor')};
  z-index: 999;
`;

export const useModal = (initialContent = null, successCallback, errorCallback) => {
  const [content, setContent] = useState(initialContent);
  const [showClose, setShowClose] = useState(initialContent);
  const [containerClassName, setClassName] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [failMsg, setFailMsg] = useState(null);
  const [hasCloseButton, setHasCloseButton] = useState(true);
  const resetModal = () => {
    setContent(null);
    setSuccessMsg(null);
    setFailMsg(null);
    if (errorCallback) {
      errorCallback();
    }
  };
  return {
    setSuccess: msg => setSuccessMsg(msg),
    setFail: msg => setFailMsg(msg),
    setModal: (modalContent, showCloseButton = false, className = '', closeButton = true) => {
      setContent(modalContent);
      setShowClose(showCloseButton);
      setClassName(className);
      setHasCloseButton(closeButton);
    },
    modal: (successMsg || failMsg || content) && (
      <Container className={containerClassName}>
        <InnerContainer className={'modalContainer'}>
          {showClose && !successMsg && hasCloseButton && (
            <CloseButton className="closeButton" white onClick={() => resetModal(null)}>
              ✖
            </CloseButton>
          )}
          {failMsg && <Fail message={failMsg} closeHandler={() => resetModal()} showIcon={false} />}
          {successMsg && (
            <Success
              message={successMsg}
              closeHandler={() => {
                resetModal();
                if (successCallback) successCallback();
              }}
            />
          )}
          {!successMsg && !failMsg && content}
        </InnerContainer>
      </Container>
    )
  };
};
